import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ICompany, IFilters, IPagination, IUser } from 'src/app/modules/authorization/store/types';
import { IAdminTimesheetsFilters, IAppUsageFilters } from 'src/app/modules/logged/dashboard/store/types';
import { IPayroll } from 'src/app/modules/logged/payrolls/store/types';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    constructor(private apiService: ApiService) { }

    public getChartData(): Observable<any> {
        return this.apiService.get('/invoices/statistics/invoicesAndWorkersChart');
    }

    public fetchAllCompaniesForDashboard(data: IAdminTimesheetsFilters): Observable<ICompany[]> {
        return this.apiService.get('/companies/admin-dashboard', data);
    }

    public fetchAllPayrollsFromCompanyForDashboard(companyID: string, data: IAdminTimesheetsFilters): Observable<IPagination<IPayroll>> {
        return this.apiService.get(`/companies/admin-dashboard/${companyID}/payrolls`, data);
    }

    public getSubcontractorsStatistics(): Observable<any> {
        return this.apiService.get('/subcontractors/statistics/subcontractorsStatistics');
    }

    public updateTimesheet(id: string, data: {}): Observable<any> {
        return this.apiService.put(`/payrolls/${id}`, data);
    }

    public fetchAppUsage(data: IAppUsageFilters): Observable<IPagination<IUser>> {
        return this.apiService.get('/users/last-logins', data);
    }

    public fetchPayrunMonthlyLogs(): Observable<{ total: number }> {
        return this.apiService.get('/logs/payrun-monthly');
    }
}
